function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__a",
  x1: "30.26%",
  x2: "24.949%",
  y1: "16.788%",
  y2: "103.696%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__d",
  x1: "65.901%",
  x2: "34.888%",
  y1: "3.622%",
  y2: "94.701%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__e",
  x1: "75.365%",
  x2: "29.95%",
  y1: "35.753%",
  y2: "57.831%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__f",
  x1: "75.31%",
  x2: "25.946%",
  y1: "3.622%",
  y2: "94.701%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__g",
  x1: "0%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__h",
  x1: "75.31%",
  x2: "25.946%",
  y1: "49.605%",
  y2: "50.381%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__i",
  x1: "25.417%",
  x2: "35.389%",
  y1: "-101.529%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__j",
  x1: "0%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__k",
  x1: "75.227%",
  x2: "26.024%",
  y1: "3.622%",
  y2: "94.701%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__l",
  x1: "12.534%",
  x2: "49.975%",
  y1: "-12.024%",
  y2: "65.725%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.934%",
  stopColor: "#48D59F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__m",
  x1: "50%",
  x2: "50%",
  y1: "5.339%",
  y2: "105.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "test_svg__n",
  x1: "50%",
  x2: "50%",
  y1: "5.339%",
  y2: "105.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})), /*#__PURE__*/React.createElement("path", {
  id: "test_svg__b",
  d: "M0 0h311v372H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__a)",
  d: "M8.035 145.386C-62.836 276.952 366.365 394.772 321.8 281c-35.518-90.677 92.016-56.535 66.5-135.614-30.704-95.16-332.263-89.114-380.266 0z",
  transform: "matrix(-1 0 0 1 391.817 0)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 373 0)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "test_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#test_svg__b"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#111",
  strokeLinecap: "square",
  strokeOpacity: 0.05,
  mask: "url(#test_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M395 352.5h-602m602-161h-602m602 40h-602m602 41h-602m602 40h-602m602-282h-602m602 40h-602m602 41h-602m602 40h-602m281 321v-602m-40 602v-602m-41 602v-602m242 602v-602m-40 602v-602m-41 602v-602m-40 602v-602m242 602v-602m-40 602v-602m-41 602v-602"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__d)",
  d: "M5.837 30C2.613 30 0 32.634 0 35.88v205.24c0 3.248 2.613 5.88 5.837 5.88h160.326c3.225 0 5.837-2.632 5.837-5.88V35.88c0-3.246-2.612-5.88-5.837-5.88H5.837z",
  transform: "translate(201 10)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M219 237h134V60H219z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__e)",
  d: "M70.856 0c-5.81 0-10.52 4.844-10.52 10.82v5.113h-5.601c-5.377 0-9.735 4.483-9.735 10.013V38h82V25.946c0-5.53-4.358-10.013-9.733-10.013h-5.603V10.82c0-5.976-4.708-10.82-10.519-10.82h-30.29z",
  transform: "translate(201 10)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__f)",
  d: "M35 165h21v-21H35zm0-71h21V73H35zm0 34h21v-21H35zm0 71h21v-21H35z",
  transform: "translate(201 10)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__g)",
  d: "M44.817 83.723l-4.813-5.027L37 81.834 44.817 90 60 74.137 56.996 71zm0 37l-4.813-5.026L37 118.834 44.817 127 60 111.139 56.996 108z",
  transform: "translate(201 10)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__h)",
  d: "M68 157h65v-6H68zm0 33h65v-6H68zm0-101h65v-6H68zm0 34h65v-6H68z",
  transform: "translate(201 10)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__i)",
  d: "M80.277 0c-4.563 0-8.263 3.687-8.263 8.235s3.7 8.236 8.263 8.236h.825v28.307a67.312 67.312 0 01-11.58 37.74L6.63 175.416c-17.224 25.44 1.12 59.72 31.91 59.638 22.531-.062 44.665-.078 56.964.03v.26c.087-.085 1.861-.151 4.946-.201 3.083.05 4.858.116 4.945.201v-.26c12.299-.108 34.43-.092 56.96-.03 22.56.06 38.439-18.323 38.544-38.16v-.393c-.036-7.117-2.107-14.405-6.63-21.085l-62.892-92.898a67.319 67.319 0 01-11.58-37.74V16.47c4.563 0 8.262-3.688 8.262-8.236S124.359 0 119.797 0h-39.52z",
  transform: "translate(25.27 61.642)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__j)",
  d: "M183.466 182.737l-22.294-32.897c-17.96-.808-19.181-7.482-39.425-7.482-21.536 0-21.536 7.559-43.077 7.559-18.476 0-21.102-5.563-35.062-7.143l-27.076 39.963c-5.495 8.11-6.027 18.11-1.411 26.75 4.607 8.64 13.222 13.795 23.045 13.795h.076c11.796-.03 22.225-.045 31.008-.045 11.234 0 19.955.022 25.93.076l4.82.045 4.826-.045c5.967-.054 14.689-.076 25.923-.076 8.782 0 19.212.015 31 .045h.084c9.822 0 18.438-5.155 23.053-13.794 4.607-8.64 4.076-18.641-1.42-26.75",
  transform: "translate(25.27 61.642)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M147.07 152.606c-9.246-13.674-14.138-29.62-14.138-46.116V77.802h-14.825v28.688c0 16.496-4.891 32.442-14.14 46.116l-36.966 54.657c14.485 1.643 17.21 7.427 36.384 7.427 22.355 0 22.355-7.859 44.703-7.859 21.008 0 22.275 6.94 40.913 7.78l-41.93-62.005z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__k)",
  d: "M.23 77.573c-.235 43.078 34.438 78.19 77.447 78.427 43.005.235 78.062-34.495 78.297-77.573C156.208 35.35 121.535.236 78.526.002 78.38 0 78.24 0 78.092 0 35.287.004.464 34.644.23 77.573",
  transform: "translate(94 179)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M124.775 302.82c-25.855-25.935-25.624-67.754.514-93.406 26.138-25.653 68.286-25.424 94.14.508 25.854 25.935 25.623 67.754-.515 93.407-26.138 25.652-68.286 25.423-94.139-.51"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__l)",
  d: "M75 83l42-41.718C105.404 29.762 90.212 24 75 24v59z",
  transform: "translate(94 179)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D00252",
  d: "M193 307.852c-.081 14.912 11.94 27.066 26.853 27.148 14.91.081 27.066-11.94 27.147-26.852.081-14.912-11.94-27.066-26.853-27.147l-.15-.001c-14.842.001-26.916 11.992-26.997 26.852"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__m)",
  d: "M73 24h10v59H73z",
  transform: "translate(94 179)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#test_svg__n)",
  transform: "rotate(90 50.5 214.5)",
  d: "M88 58h10v40H88z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M217 291h7v21h-7zm0 27h7v6h-7z"
})));

function SvgTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392 372"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgTest as ReactComponent };